/******************************************************************************
 * Copyright © 2018 Apollo Foundation                                         *
 *                                                                            *
 ******************************************************************************/

import { createStore, applyMiddleware, compose, Action } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
// import createHistory from 'history/createBrowserHistory'
import rootReducer from './ducks';

// export const history = createHistory();

const initialState = {};
const middleware = [thunk];

const composedEnhancers = composeWithDevTools(applyMiddleware(...middleware));

const store = createStore(rootReducer, initialState, composedEnhancers);

export type AppState = ReturnType<typeof rootReducer>;
export type GetState = () => AppState;
export type ThunkAppDispatch = ThunkDispatch<AppState, void, Action>;
export type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;

export default store;
